'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import UIStepperButton from './UIStepperButton';
import omit from '../utils/underscore/omit';
export default function UINextButton(props) {
  return /*#__PURE__*/_jsx(UIStepperButton, Object.assign({
    "aria-label": I18n.text('salesUI.UINextButton.label'),
    iconName: "next"
  }, props));
}
const EXCLUDED_STEPPER_BUTTON_PROP_NAMES = ['iconName', 'aria-label'];
UINextButton.propTypes = Object.assign({}, omit(UIStepperButton.propTypes, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UINextButton.defaultProps = Object.assign({}, omit(UIStepperButton.defaultProps, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UINextButton.displayName = 'UINextButton';